module.exports = __webpack_public_path__ + "img/cool-menu-title.c1dd6ae6.svg";